import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { getIncidents, resetGotoIncident } from "../store/actions/incidentActions";
import { Redirect } from 'react-router-dom';





import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';


import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";

import IncidentDetailsForm from "../components/Incidents/IncidentOverlay";

import IncidentsTable from "../components/Incidents/IncidentsTable";




function Incidents(props) {

    const { match, token, getIncidentsFN, incidents, resetGotoIncidentFN } = props;


    const [currentIncident, setCurrentIncident] = useState(null);


    const [isIncidentOpen, setIsIncidentOpen] = useState(false);


    useEffect(() => {
        resetGotoIncidentFN();
        getIncidentsFN(match.params.risk_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const openpopup = (data) => {
        setCurrentIncident(data);
        setIsIncidentOpen(true);
    }
    const closeIncident = () => {
        ////console.log("closeIncident")
        setIsIncidentOpen(false);

    }




    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full overflow-hidden"> {/* Prevent horizontal scrolling */}
                <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" /> {/* Adjust the top to match TopBar height */}
                <div className="flex flex-col w-full p-4 overflow-auto"> {/* Adjust the margin-left to match Sidebar width */}

                    <div className="h-full w-full mt-4"> {/* Remove overflow-x-auto to prevent scrolling */}
                        <IncidentsTable data={incidents} openpopup={openpopup} />
                        <div style={{ height: "20px" }}></div>

                    </div>
                </div>
            </div>





            <Popup
                open={isIncidentOpen}
                onClose={closeIncident}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}

            >
                <IncidentDetailsForm closeIncident={closeIncident} currentIncident={currentIncident} not_editable={true} />
            </Popup>


        </div>
    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        incidents: state.incident.incidents,



    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getIncidentsFN: (risk_id) => dispatch(getIncidents(risk_id)),
        resetGotoIncidentFN: () => dispatch(resetGotoIncident()),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Incidents);
